import type { ChainModifiers, Entry, EntryFieldTypes, EntrySkeletonType, LocaleCode } from "contentful";
import type { TypeSimpleColumnSkeleton } from "./TypeSimpleColumn";
import type { TypeTableOfContentsSettingSkeleton } from "./TypeTableOfContentsSetting";

/**
 * Fields type definition for content type 'TypeSimpleColumnSection'
 * @name TypeSimpleColumnSectionFields
 * @type {TypeSimpleColumnSectionFields}
 * @memberof TypeSimpleColumnSection
 */
export interface TypeSimpleColumnSectionFields {
    /**
     * Field type definition for field 'internalTitle' (Internal Title)
     * @name Internal Title
     * @localized false
     */
    internalTitle?: EntryFieldTypes.Symbol;
    /**
     * Field type definition for field 'title' (Title)
     * @name Title
     * @localized false
     */
    title?: EntryFieldTypes.Symbol;
    /**
     * Field type definition for field 'columns' (Columns)
     * @name Columns
     * @localized false
     */
    columns?: EntryFieldTypes.Array<EntryFieldTypes.EntryLink<TypeSimpleColumnSkeleton>>;
    /**
     * Field type definition for field 'backgroundColor' (BackgroundColor)
     * @name BackgroundColor
     * @localized false
     */
    backgroundColor: EntryFieldTypes.Symbol<"grey" | "light-blue" | "white">;
    /**
     * Field type definition for field 'tocSetting' (tocSetting)
     * @name tocSetting
     * @localized false
     */
    tocSetting?: EntryFieldTypes.EntryLink<TypeTableOfContentsSettingSkeleton>;
}

/**
 * Entry skeleton type definition for content type 'simpleColumnSection' (Simple Column Section)
 * @name TypeSimpleColumnSectionSkeleton
 * @type {TypeSimpleColumnSectionSkeleton}
 * @author 7BjsgI9gzpO6Dv7BH5AOT6
 * @since 2018-03-23T17:09:32.373Z
 * @version 15
 */
export type TypeSimpleColumnSectionSkeleton = EntrySkeletonType<TypeSimpleColumnSectionFields, "simpleColumnSection">;
/**
 * Entry type definition for content type 'simpleColumnSection' (Simple Column Section)
 * @name TypeSimpleColumnSection
 * @type {TypeSimpleColumnSection}
 * @author 7BjsgI9gzpO6Dv7BH5AOT6
 * @since 2018-03-23T17:09:32.373Z
 * @version 15
 */
export type TypeSimpleColumnSection<Modifiers extends ChainModifiers, Locales extends LocaleCode = LocaleCode> = Entry<TypeSimpleColumnSectionSkeleton, Modifiers, Locales>;

export function isTypeSimpleColumnSection<Modifiers extends ChainModifiers, Locales extends LocaleCode>(entry: Entry<EntrySkeletonType, Modifiers, Locales>): entry is TypeSimpleColumnSection<Modifiers, Locales> {
    return entry.sys.contentType.sys.id === 'simpleColumnSection'
}
